
export class Station {
  stationId: string = null;
  stationName: string = null;
  countryId: string = null;
  stationLatitude: any = null;
  stationLongitude: any = null;

  constructor(data: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/StationModel.ts